
import React, {
  useCallback,
  useContext,
  useEffect,
  useId,
  useMemo,
  useRef,
  useState,
} from "react";
import Sidebar from "../../CommonComponent/sidebar/Sidebar";
import TopNavbar from "../../CommonComponent/topNavbar/TopNavbar";
import { Footer } from "../../Footer";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import {
  Col,
  Button,
  Form,
  Row,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import DataTable from "react-data-table-component";
import { ModalBox } from "../Outer/Modal";
import Table from "react-bootstrap/Table";
import Image from "react-bootstrap/Image";
import * as icons from "react-bootstrap-icons";
import { CloseRounded, WidgetsRounded } from "@mui/icons-material";
import { MultiSelect } from "react-multi-select-component";
import {
  AuctionAll,
  SportAllMap,
  BidStatus,
  RefreshToken,
  SubscribeManager,
  ManagerGetAll,
  PlayerGetSubscribeManager,
  debounce,
  BidStatusData,
  AuctionPlaceBid,
  GetSubScription,
} from "../../redux/auth-reducer/auth-service";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import * as signalR from "@microsoft/signalr";
import { ToastContainer, toast } from "react-toastify";
import { Context } from "../../redux/Context";
import moment from "moment";
import { Loader } from "rsuite";
import flags from "react-phone-number-input/flags";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import '../../index.css'
import introJs from 'intro.js';
import 'intro.js/introjs.css';
import { setCurrentPageCount, setStatus } from "../../redux/auth-reducer/slice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

function AuctionPlayer() {
  const itemvalue = localStorage.getItem("abc");

  if (itemvalue == 1) {
    alert(itemvalue);
    window.location.reload();
  }
  const [data, setData] = useState(false);
  const [searchTextClose, setSearchTextClose] = useState("");
  const [searchTextUpcomingLive, setSearchTextUpcomingLive] = useState("");
  const [searchTextUpcomingLiveAuction, setSearchTextUpcomingLiveAuction] =
    useState("");
  const [searchTextCloseAuction, setSearchTextCloseAuction] = useState("");
  const [showView, setShowView] = useState(false);
  const [itemlist, setitemList] = useState([]);
  const [itemsport, setitemSport] = useState([]);
  const [count, setCount] = useState(0);
  const [timestamp, setTimestamp] = useState();
  const [filterUpcomingLiveAuction, setFilterUpcomingLiveAuction] = useState(
    []
  );
  const [filterClosedAuction, setFilterClosedAuction] = useState([]);
  const [page, setpage] = useState(1);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  // const [hubConnection, setHubConnection] = useState(null);
  const [signalRData, setSignalRData] = useState([]);
  const [BidStatusAuction, setBidStatusAuction] = useState([]);
  const [allManager, setAllManager] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [subscribedManagers, SetSubscribedManagers] = useState([]);
  const [dataSingalR, setDataSingalR] = useState([]);
  const [totalPageSize, setTotalPageSize] = useState([]);
  const [totalRowsClosedArchive, setTotalRowsClosedArchive] = useState();
  const [totalRowsLiveUpcoming, setTotalRowsLiveUpcoming] = useState();
  const { hubConnection } = useContext(Context);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const pageOptions = [10, 20, 30, 50];
  // const [key, setKey] = useState('Live');
  const [currentPage1, setCurrentPage1] = useState(1);
  const [perPage1, setPerPage1] = useState(10);
  const pageOptions1 = [10, 20, 30, 50];
  const [totalCount, setTotalCount] = useState();
  const [dataLength, setDataLength] = useState();
    const [messageSubscribe, setMessageSubscribe] = useState()
   const loginInstructionStatus = useSelector(state => state?.instruction?.status);
   const currentPageCount = useSelector((state) => state.instruction.currentPage);
  const isUser = JSON.parse(localStorage.getItem("isUser"));
  const userId = isUser?.userId;
  const loginInstruction =  isUser?.isUserInstruction;
  const dispatch =  useDispatch()
  const hasFetchedData = useRef(false);
  const [auctionPlaceModal, setAuctionPlaceModal] = useState(false)
      const [auctionPlacedata, setAuctionPlaceData] = useState(null)
      const [dataPlayer, setDataPlayer] = useState([]);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [searchCurrentPage, setSearchCurrentPage] = useState(1);
  const [searchCurrentPage1, setSearchCurrentPage1] = useState(1);
  const [key, setKey] = useState(() => {
    return localStorage.getItem("activeTab") || "Live";
  });
  let instructionStatus = localStorage.getItem("instruction");
  const loginInstruction1 =  true

  useEffect(() => {
    localStorage.setItem("activeTab", key);
    const fetchPlayerData = async () => {
        try {
            const result = await PlayerGetSubscribeManager();
            setDataPlayer(result?.data || []);
             const response = await GetSubScription();
                 setMessageSubscribe(response?.data?.message)
        } catch (error) {
            console.error("Error fetching subscribe manager:", error);
            setDataPlayer([]);
        }
    };

    fetchPlayerData();
}, [key]);

  // useEffect(() => {
  //   localStorage.setItem("activeTab", key);
  // }, [key]);

 const actionTourStarted = useRef(false);
    const steps = [
        {
          element: '#auction',
          intro: 'This section showcases both ongoing and upcoming auctions where players are available for bidding.',
          position: 'right'
        },
        {
          element: '#manager-select',
          intro: 'This section list all available Managers.  To request access to a Manager’s auctions, click the box beside the Manager’s name.',
          position: 'left'
        },
        {
          element: '.search-auction',
          intro: 'Your request has been submitted.  Your Player account will be given auction access once the Manager responds to your request.',
          position: 'right'
        },
        {
          element: '#auction-table',
          intro: 'This list displays details of each auction, including participating teams, start time, and current bidding status.',
          position: 'top'
        },
        {
          element: '.place-bid-btn', // the blue "Place Bid" button
          // intro: 'You can place a bid by clicking the button when the auction is active.',
          // intro: `When an auction becomes active, a <strong>blue "Place a Bid"</strong> button will appear beside the auction listing.<br><br>
          //         You'll be able to click it to participate in the bidding.`,
          intro: `
                  When an auction becomes active, a <strong style="color: #fff;">blue "Place Bid"</strong> button will appear.<br><br>
                  It will look like this:<br>
                  <button style="
                    background-color: #043bc7;
                    color: white;
                    padding: 6px 12px;
                    border: none;
                    border-radius: 4px;
                    font-weight: bold;
                    cursor: default;
                    margin-top: 8px;
                  ">
                    Place Bid
                  </button><br><br>
                  You can click this button to place your bid during live auctions.
                `,
          position: 'bottom'
        }
      ];

   const startTour = () => {
        introJs().setOptions({
            steps: steps,
            showBullets: false,
            nextLabel: 'Next',
            prevLabel: 'Previous',
            doneLabel: 'Finish',
            exitOnOverlayClick: false,
             skipLabel: '', 
             tooltipClass: 'custom-intro-tooltip',
        }).oncomplete(() => {
                        localStorage.removeItem('instruction')
                        dispatch(setStatus(false)); 
                    }).start();
    };
    useEffect(() => {
        if ((!actionTourStarted.current  && loginInstruction === true && loginInstructionStatus === loginInstruction) || instructionStatus === 'true') {
            startTour();
            actionTourStarted.current = true;
        }
    }, [instructionStatus]);
  

  const navigate = useNavigate();
  const sidebarfun = () => {
    setData(!data);
  };

  // useEffect(() => {
  //   async function apiCalling() {

  //     let temp_sports = await SportAllMap();
  //     setitemSport(temp_sports?.data?.data?.dataList);

  //   }
  //   apiCalling();
  // }, []);

  // const BidAllFn = async (data) => {

  //   await BidStatus(data).then((response) => {

  //     setTotalPageSize(response?.data?.data?.totalPageSize)
  //     const selectedLabels = selectedOptions?.map(option => option.label).filter(label => label);

  //     const filteredData = response?.data?.data?.dataList?.length > 0 ? response?.data?.data?.dataList?.map((e) => {
  //       let remainingtimer = e.status == "Upcoming" ? new Date() : moment().add(e?.remainingBidTime.split(":")[0], 'minutes').add(e?.remainingBidTime.split(":")[1], 'seconds').format()
  //       return { ...e, recievedAt: remainingtimer, status: (e.status == "Live" && e.remainingBidTime == "00:00") ? "Closed" : e.status }
  //     })?.filter(item => {

  //       const match = selectedLabels?.includes(item.createdByName);

  //       return match;
  //     }) : [];

  //     setBidStatusAuction(filteredData);
  //     // setitemList(response?.data);

  //   })
  // }


  const BidAllFn = async (data) => {
    setLoading(true);
    await BidStatusData(data).then((response) => {
      setLoading(false);

      // setTotalPageSize(response?.data?.data?.totalPageSize);
      const totalClosedArchiveRows = response?.data?.data?.totalPageSize;
      const totalCount = response?.data?.data?.totalRecordCount;
      setTotalCount(totalCount);

      setTotalRowsClosedArchive(totalClosedArchiveRows);
      setTotalRowsLiveUpcoming(totalClosedArchiveRows);
      setDataLength(response?.data?.data?.dataList?.length);
      const selectedLabels =
        selectedOptions
          ?.filter((option) => option.status === "Approved")
          .map((option) => option.label)
          .filter((label) => label) || [];

      const filteredData =
        response?.data?.data?.dataList?.length > 0
          ? response?.data?.data?.dataList
              ?.map((e) => {
                let remainingtimer =
                  e.status === "Upcoming"
                    ? new Date()
                    : moment()
                        .add(e?.remainingBidTime?.split(":")[0], "minutes")
                        .add(e?.remainingBidTime?.split(":")[1], "seconds")
                        .format();
                return {
                  ...e,
                  recievedAt: remainingtimer,
                  status:
                    e.status === "Live" && e.remainingBidTime === "00:00"
                      ? "Closed"
                      : e.status,
                };
              })
              ?.filter((item) => {
                const match = selectedLabels?.includes(item.createdByName);
                return match;
              })
          : [];

      // Change status from Upcoming to Live if any auctionId has Closed and Upcoming

      const auctionIds = new Set(filteredData.map((item) => item.auctionId));

      auctionIds.forEach((auctionId) => {
        const auctionItems = filteredData.filter(
          (item) => item.auctionId === auctionId
        );

        const hasClosed = auctionItems.some((item) => item.status === "Closed");

        const hasUpcoming = auctionItems.some(
          (item) => item.status === "Upcoming"
        );
        const hasLive = auctionItems.some((item) => item.status === "Live");

        if (hasClosed && hasUpcoming && !hasLive) {
          const firstUpcomingIndex = auctionItems.findIndex(
            (item) => item.status === "Upcoming"
          );

          // if (firstUpcomingIndex !== -1) {

          //   auctionItems[firstUpcomingIndex].status = "Live";

          //   const bidTimeFloat = parseFloat(itemToUpdate.bidTime);

          //   const minutesPart = Math.floor(bidTimeFloat);

          //   const secondsPart = Math.round((bidTimeFloat - minutesPart) * 60);

          //   itemToUpdate.recievedAt = moment()

          //     .add(minutesPart, "minutes")

          //     .add(secondsPart, "seconds")

          //     .format();

          // }

          if (firstUpcomingIndex !== -1) {
            const itemToUpdate = auctionItems[firstUpcomingIndex];

            itemToUpdate.status = "Live";

            const bidTimeFloat = parseFloat(itemToUpdate.bidTime);

            const minutesPart = Math.floor(bidTimeFloat);

            const secondsPart = Math.round((bidTimeFloat - minutesPart) * 60);

            itemToUpdate.recievedAt = moment()
              .add(minutesPart, "minutes")

              .add(secondsPart, "seconds")

              .format();
          }
        }
      });

      setBidStatusAuction(filteredData);

      // Calculate total rows for Live and Upcoming

      // Calculate total rows for Closed and Archive

      // setTotalRows(response.data.data.totalPageSize || 0);
    });
  };

  useEffect(() => {
    setLoading(true);
    const data = {
      // SearchTerm: "Live, Upcoming, Paused",
      SearchTerm: searchTextUpcomingLive ? `Live, Upcoming, Paused, ${searchTextUpcomingLive}`  : "Live, Upcoming, Paused",
      SortColumn: searchTextUpcomingLive !== "" ? "" :  "status",
      SortOrder: true,
      PageNumber: currentPageCount,
      PageSize: perPage,
    };
    const data1 = {
      // SearchTerm: "Closed, Archive",
      SearchTerm: searchTextUpcomingLive ? `Closed, Archive, ${searchTextUpcomingLive}` : "Closed, Archive",
      SortColumn: searchTextUpcomingLive !== "" ? "" :  "status",
      SortOrder: false,
      PageNumber: currentPage1,
      PageSize: perPage1,
    };

    if (key === "Live") {
      BidAllFn(data);

      const handleVisibilityChange = () => {
        if (document.visibilityState === "visible") {
          BidAllFn(data); // Call the function again when the page becomes visible
        }
      };

      document.addEventListener("visibilitychange", handleVisibilityChange);

      // Cleanup the event listener on component unmount
      return () => {
        document.removeEventListener(
          "visibilitychange",
          handleVisibilityChange
        );
      };
    } else if (key === "Closed") {
      BidAllFn(data1);
      const handleVisibilityChange = () => {
        if (document.visibilityState === "visible") {
          BidAllFn(data1); // Call the function again when the page becomes visible
        }
      };

      document.addEventListener("visibilitychange", handleVisibilityChange);

      // Cleanup the event listener on component unmount
      return () => {
        document.removeEventListener(
          "visibilitychange",
          handleVisibilityChange
        );
      };
      // Fetch data for Winner when the tab is selected
    }
  }, [
    key,
    currentPageCount,
    currentPage1,
    totalRowsLiveUpcoming,
    totalRowsClosedArchive,
    perPage,
    perPage1,
    selectedOptions,
  ]);

  // Polling every 5 seconds for Live tab to check for live auction updates without refreshing
  useEffect(() => {
    let intervalId;
    if (key === "Live") {
      intervalId = setInterval(async () => {
        const data = {
          // SearchTerm: "Live, Upcoming, Paused",
          SearchTerm: searchTextUpcomingLive ? `Live, Upcoming, Paused, ${searchTextUpcomingLive}`  : "Live, Upcoming, Paused",
          SortColumn: searchTextUpcomingLive !== "" ? "" :  "status",
          SortOrder: true,
          PageNumber: currentPageCount,
          PageSize: perPage,
        };
        await BidStatusData(data).then((response) => {
          const totalClosedArchiveRows = response?.data?.data?.totalPageSize;
          const totalCount = response?.data?.data?.totalRecordCount;
          setTotalCount(totalCount);
          setTotalRowsClosedArchive(totalClosedArchiveRows);
          setTotalRowsLiveUpcoming(totalClosedArchiveRows);
          setDataLength(response?.data?.data?.dataList?.length);
          const selectedLabels =
            selectedOptions
              ?.filter((option) => option.status === "Approved")
              .map((option) => option.label)
              .filter((label) => label) || [];
          const filteredData =
            response?.data?.data?.dataList?.length > 0
              ? response?.data?.data?.dataList
                  ?.map((e) => {
                    let remainingtimer =
                      e.status === "Upcoming"
                        ? new Date()
                        : moment()
                            .add(e?.remainingBidTime?.split(":")[0], "minutes")
                            .add(e?.remainingBidTime?.split(":")[1], "seconds")
                            .format();
                    return {
                      ...e,
                      recievedAt: remainingtimer,
                      status:
                        e.status === "Live" && e.remainingBidTime === "00:00"
                          ? "Closed"
                          : e.status,
                    };
                  })
                  ?.filter((item) => {
                    const match = selectedLabels?.includes(item.createdByName);
                    return match;
                  })
              : [];
          const auctionIds = new Set(filteredData.map((item) => item.auctionId));
          auctionIds.forEach((auctionId) => {
            const auctionItems = filteredData.filter(
              (item) => item.auctionId === auctionId
            );
            const hasClosed = auctionItems.some((item) => item.status === "Closed");
            const hasUpcoming = auctionItems.some(
              (item) => item.status === "Upcoming"
            );
            const hasLive = auctionItems.some((item) => item.status === "Live");
            if (hasClosed && hasUpcoming && !hasLive) {
              const firstUpcomingIndex = auctionItems.findIndex(
                (item) => item.status === "Upcoming"
              );
              if (firstUpcomingIndex !== -1) {
                const itemToUpdate = auctionItems[firstUpcomingIndex];
                itemToUpdate.status = "Live";
                const bidTimeFloat = parseFloat(itemToUpdate.bidTime);
                const minutesPart = Math.floor(bidTimeFloat);
                const secondsPart = Math.round((bidTimeFloat - minutesPart) * 60);
                itemToUpdate.recievedAt = moment()
                  .add(minutesPart, "minutes")
                  .add(secondsPart, "seconds")
                  .format();
              }
            }
          });
          setBidStatusAuction(filteredData);
        });
      }, 5000); // 5 seconds
    }
    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [key, currentPageCount, perPage, selectedOptions]);

  const handlePerPageChange = (event) => {
    const newPerPage = Number(event.target.value);
    const data = {
      // SearchTerm: "Live, Upcoming, Paused",
      SearchTerm: searchTextUpcomingLive ? `Live, Upcoming, Paused, ${searchTextUpcomingLive}`  : "Live, Upcoming, Paused",
      SortColumn:searchTextUpcomingLive !== "" ? "" :  "status", 
      SortOrder: true,
      PageNumber: currentPageCount,
      PageSize: perPage,
    };
    BidAllFn(data);
    setPerPage(newPerPage);
dispatch(setCurrentPageCount(1))
    // setCurrentPage(1); // Reset to first page when items per page changes
  };

  const handlePerPageChange1 = (event) => {
    const newPerPage = Number(event.target.value);

    const data1 = {
      SearchTerm: searchTextUpcomingLive ? `Closed, Archive, ${searchTextUpcomingLive}` : "Closed, Archive",
      // SearchTerm: "Closed, Archive",
      SortColumn: searchTextUpcomingLive !== "" ? "" :  "status",
      SortOrder: false,
      PageNumber: currentPage1,
      PageSize: perPage1,
    };
    BidAllFn(data1);
    setPerPage1(newPerPage);
    setCurrentPage1(1); // Reset to first page when items per page changes
  };

  const handleNextPage1 = () => {
    if (key === "Closed") {
      if (currentPage1 < Math.ceil(totalRowsClosedArchive)) {
        setCurrentPage1((prevPage) => prevPage + 1);
      }
    } else {
      // Switch to Closed tab if on Live tab
      setKey("Closed");
    }
  };

  const handlePreviousPage1 = () => {
    if (currentPage1 > 1) {
      setCurrentPage1((prevPage) => prevPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPageCount < Math.ceil(totalRowsLiveUpcoming)) {
      // setCurrentPage((prevPage) => prevPage + 1);
       dispatch(setCurrentPageCount(currentPageCount + 1));
    }
  };

  const handlePreviousPage = () => {
    if (currentPageCount > 1) {
      // setCurrentPage((prevPage) => prevPage - 1);
      dispatch(setCurrentPageCount(currentPageCount - 1));
    }
  };

  useEffect(() => {
    const getSubscribeManager = async () => {
      await PlayerGetSubscribeManager(userId).then((response) => {
        SetSubscribedManagers(response?.data);
      });
    };
    getSubscribeManager();
  }, [userId, selectedOptions]);

  // useEffect(() => {
  // const BidStatusAll = async () => {
  //   await AuctionAll().then((res) => {

  //     const selectedLabels = selectedOptions?.map(option => option.label).filter(label => label);

  //     const filteredData = res?.data?.length > 0 ? res?.data?.map((e) => {
  //       let remainingtimer = e.status == "Upcoming" ? new Date() : moment().add(e?.remainingBidTime.split(":")[0], 'minutes').add(e?.remainingBidTime.split(":")[1], 'seconds').format()
  //       return { ...e, recievedAt: remainingtimer, status: (e.status == "Live" && e.remainingBidTime == "00:00") ? "Closed" : e.status }
  //     })?.filter(item => {

  //       const match = selectedLabels?.includes(item.createdByName);

  //       return match;
  //     }) : [];

  //     setBidStatusAuction(filteredData);
  //   });
  // }
  // BidStatusAll()
  // }, [selectedOptions])

  useEffect(() => {
    const getAllManagers = async () => {
      await ManagerGetAll().then((res) => {
        setAllManager(res?.data?.data?.dataList);
      });
    };
    getAllManagers();
  }, []);

  // const approvedManager = subscribedManagers?.filter(
  //   (manager) => manager.status === "Approved" || manager.status === "Pending"
  // );

 const approvedManager = subscribedManagers?.filter(manager => manager.status === "Approved" || manager.status === "Pending");

  const managerNames = approvedManager?.map((manager) => ({
    label: manager?.managerName,
    value: manager?.managerId,
    status: manager?.status,
    disabled: manager?.status === 'Pending' ,
  }));

  useEffect(() => {
    if (JSON.stringify(selectedOptions) !== JSON.stringify(managerNames)) {
      setSelectedOptions(managerNames);
    }
  }, [managerNames]);


  // useEffect(() => {
  //   const data = {
  //     "PageNumber": page,
  //     "PageSize": perPage
  //   }
  //   BidAllFn(data);
  //   localStorage.setItem("abc", 0);

  // }, [selectedOptions, page]);

  var stDate, stTime;
  if (timestamp) {
    [stDate, stTime] = timestamp?.split("T");
  } else {
    stDate = "";
    stTime = "";
  }

  function convertUTCToLocalTime(utcDateString) {
    const date = new Date(utcDateString);
    return date.toString(); // Or use date.toLocaleString() for better format
  }

  function addLiveTeam(data) {
    if (!data) return;
    if (data?.status != "Upcoming") return;

    setBidStatusAuction((prev) => {
      let newData = prev?.map((item) => {
        if (
          data.auctionId == item.auctionId &&
          data.teamId == item.teamId &&
          item.status != "Live"
        ) {
          let remainingtimer = moment().add(item.bidTime, "minutes").format();
          return { ...item, status: "Live", recievedAt: remainingtimer };
        }
        //  else if(data.auctionId == item.auctionId && data.teamId == item.teamId){
        //   return { ...item, status: "Closed" }
        //   // return { ...item }
        //  }
        return item;
      });

      // setTimer(newData.filter((event) => event.status === "Upcoming" || event.status === "Live" || event.status === "Paused"))
      return newData;
    });
  }

  function addLiveToNextTeam(data) {
    if (data.status != "Live") return;

    setBidStatusAuction((prev) => {
      let newData = prev?.map((item) => {
        if (
          data.auctionId == item.auctionId &&
          data.teamId + 1 == item.teamId &&
          item.status != "Live"
        ) {
          let remainingtimer = moment().add(item.bidTime, "minutes").format();
          // let remainingtimer = moment().add(item?.bidTime.split(":")[1], 'minutes').add(item?.bidTime.split(":")[1], 'seconds').format();

          return { ...item, status: "Live", recievedAt: remainingtimer };
        } else if (
          data.auctionId == item.auctionId &&
          data.teamId == item.teamId
        ) {
          return { ...item, status: "Closed" };
          // return { ...item }
        }
        return item;
      });

      // setTimer(newData.filter((event) => event.status === "Upcoming" || event.status === "Live" || event.status === "Paused"))
      return newData;
    });
  }

  function addZero(num) {
    if (num < 10) {
      return `0${num}`;
    }
    return num;
  }

  // function getExectTime(end, nextItemStart) {
  //   let now = moment();
  //   var diffDays = nextItemStart.status == "Upcoming" ? ((new Date(nextItemStart.startDate + 'Z')).getTime() - (new Date()).getTime()) : ((new Date(end)).getTime() - (new Date()).getTime());
  //   var minutes = Math.abs(parseInt(diffDays / (1000 * 60)));
  //   let allAuctionBid = BidStatusAuction.filter((e) => e.auctionId == nextItemStart.auctionId).sort(function (a, b) { return a.teamId - b.teamId });
  //   let isAnyLive = allAuctionBid.some((e) => e.status == "Live")

  //   if (!isAnyLive && nextItemStart.status == "Upcoming" && minutes == 0 && new Date(diffDays).getSeconds() == 0) {
  //     addLiveTeam(allAuctionBid[0])
  //   } else if (diffDays && minutes == 0 && new Date(diffDays).getSeconds() == 0 && nextItemStart.status != "Upcoming") {
  //     addLiveToNextTeam(nextItemStart)
  //   }
  //   return nextItemStart.status == "Live" ? `${minutes > 0 ? addZero(minutes) : "00"}:${new Date(diffDays).getSeconds() > 0 ? addZero(new Date(diffDays).getSeconds()) : "00"}` : ""
  // }

  const viewPlacebit = async(item) => {
      const autionId  = item.auctionId
      const result = await AuctionPlaceBid(autionId)
      setAuctionPlaceData(result?.data)
      if(result){
        setAuctionPlaceModal(true)
      }
    }
  
    const handleAuctionPalceBitClosed = () => {
      setAuctionPlaceModal(false)
    }

  function getExectTime(end, nextItemStart) {
    let now = moment();
    let diffDays;

    // Determine the time difference based on the auction status
    if (nextItemStart.status === "Upcoming") {
      diffDays =
        new Date(nextItemStart.startDate + "Z").getTime() - now.valueOf();
    } else {
      diffDays = new Date(end).getTime() - now.valueOf();
    }

    const minutes = Math.max(0, Math.floor(diffDays / (1000 * 60)));
    const seconds = Math.max(0, Math.floor((diffDays % (1000 * 60)) / 1000));

    // Get all auctions for the current auctionId
    let allAuctionBid = BidStatusAuction.filter(
      (e) => e.auctionId === nextItemStart.auctionId
    );

    // Check if any auction is live
    let isAnyLive = allAuctionBid.some((e) => e.status === "Live");

    // Logic to add live team or update status
    if (
      !isAnyLive &&
      nextItemStart.status === "Upcoming" &&
      minutes === 0 &&
      seconds === 0
    ) {
    //  addLiveTeam(allAuctionBid[0]);
     // convert first show all Live auction in pandey
      addLiveTeam(allAuctionBid);
    } else if (
      diffDays &&
      minutes === 0 &&
      seconds === 0 &&
      nextItemStart.status !== "Upcoming"
    ) {
      addLiveToNextTeam(nextItemStart);
    }

    // Update status to "Closed" if time is up
    if (minutes === 0 && seconds === 0 && nextItemStart.status === "Live") {
      return "00:00"; // Return a string when closed
    }

    // Return formatted time for display
    return nextItemStart.status === "Live"
      ? `${addZero(minutes)}:${addZero(seconds)}`
      : "";
  }

  // Helper function to add leading zero
  function addZero(num) {
    return num < 10 ? `0${num}` : num;
  }

  const previousAuctionsRef = useRef([]);
  const bidStatusRef = useRef(BidStatusAuction);

  useEffect(() => {
    bidStatusRef.current = BidStatusAuction;
  }, [BidStatusAuction]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      const currentAuctions = bidStatusRef.current;
      const updatedAuctions = currentAuctions.map((item) => {
        const end = item?.endDate;
        const nextItemStart = item;
        const timeLeft = getExectTime(end, nextItemStart);

        // Update the auction status based on the time left
        if (timeLeft === "00:00") {
          return { ...item, status: "Closed", timeLeft: "00:00" };
        }

        return { ...item, timeLeft }; // Add timeLeft to the auction item for display
      });

      // Check if any auction status changed from "Live" to "Closed"
      const hasStatusChanged = updatedAuctions.some((updatedItem, index) => {
        const prevItem = previousAuctionsRef.current[index];
        return prevItem && prevItem.status === "Live" && updatedItem.status === "Closed";
      });

      if (hasStatusChanged) {
        setRefreshTrigger(prev => prev + 1);
      }

      previousAuctionsRef.current = updatedAuctions;
      setBidStatusAuction(updatedAuctions);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [BidStatusAuction]); // Empty dependency array

  useEffect(() => {
    if (refreshTrigger > 0) {
      const data = key === "Live" ? {
        // SearchTerm: "Live, Upcoming, Paused",
        SearchTerm: searchTextUpcomingLive ? `Live, Upcoming, Paused, ${searchTextUpcomingLive}`  : "Live, Upcoming, Paused",
        SortColumn: searchTextUpcomingLive !== "" ? "" :  "status",
        SortOrder: true,
        PageNumber: currentPageCount,
        PageSize: perPage,
      } : {
        SearchTerm: searchTextUpcomingLive ? `Closed, Archive, ${searchTextUpcomingLive}` : "Closed, Archive",
        // SearchTerm: "Closed, Archive",
        SortColumn: searchTextUpcomingLive !== "" ? "" :  "status",
        SortOrder: false,
        PageNumber: currentPage1,
        PageSize: perPage1,
      };
      BidAllFn(data);
    }
  }, [refreshTrigger]);

  const customSort = (rowA, rowB) => {
    const a = rowA.title.toLowerCase();
    const b = rowB.title.toLowerCase();

    if (a > b) {
      return 1;
    }

    if (b > a) {
      return -1;
    }

    return 0;
  };

  const columns = [
    {
      name: "Team Name",
      selector: (row) => (
        <>
          <OverlayTrigger
            overlay={<Tooltip>{row?.teamName}</Tooltip>}
            placement="top"
            delayShow={300}
            delayHide={150}
          >
            <p>{row?.teamName}</p>
          </OverlayTrigger>
        </>
      ),

      sortable: true,
      width: "150px",
      // sortFunction : customSort
    },
    {
      name: "Auction Name",
      selector: (row) => (
        <>
          <OverlayTrigger
            overlay={<Tooltip>{row?.auctionName}</Tooltip>}
            placement="top"
            delayShow={300}
            delayHide={150}
          >
            <p>{row?.auctionName}</p>
          </OverlayTrigger>
        </>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Contest Name",
      selector: (row) => row?.tournamentName,
      width: "200px",
      sortable: true,
    },
    {
      name: "Sport Name",
      selector: (row) => row?.sportName,
      sortable: true,
      width: "150px",
    },
    {
      name: "Start Date & Time",
      selector: (row) => {
        if (!row?.startDate) return <p>Invalid date</p>;
        return (
          <p>{dayjs(row?.startDate + "Z").format("MM/DD/YYYY hh:mm:ss A")}</p>
        );
      },
      sortable: true,
      width: "200px",
    },

    {
      name: "Bid Time Limit",
      selector: (row) => row?.bidTime,
      sortable: true,
      width: "150px",
    },
    {
      name: "Bid Status",
      selector: (row) => {
        const statusColor = {
          Upcoming: "#f9c114",
          Live: "#043bc7",
          Closed: "red",
          Paused: "red",
          Play: "green",
          Archive: "red",
        };
        return (
          <div id="bid-status">
          <span style={{ color: statusColor[row.status] }} className="bid-status">
            {row.status}{" "}
            {row.status == "Live" || row.status == "Upcoming"
              ? getExectTime(row.recievedAt, row)
              : ""}
          </span>
          </div>
        );
      },
      width: "130px",
      sortable: true,
    },

    {
      name: "Auction Winnings",
      selector: (row) => (
        <>
          <button className="tablebtn viewButton" onClick={() => viewPlacebit(row)}>
            <RemoveRedEyeOutlinedIcon />
          </button>
        </>
      ),
      sortable: true,
    },
    {
      name: "Secondary Market",
      selector: (row) =>
        row.secondaryMarket ? (
          <div className="bg-succ">Available</div>
        ) : (
          <div className="bg-dang">Unavailable</div>
        ),
      width: "150px",
      sortable: true,
    },
    {
      name: "Starting Bid",
      selector: (row) => row?.startingBid,
      sortable: true,
      width: "150px",
    },
    {
      name: "Current Bid",
      selector: (row) => row?.currentBidAmount,
      sortable: true,
      width: "150px",
    },
    {
      name: "Bid Increment",
      selector: (row) => row?.bidIncrement,
      sortable: true,
      width: "150px",
    },

    {
      name: "Created By",
      selector: (row) => (
        <>
          <OverlayTrigger
            overlay={<Tooltip>{row?.createdByName}</Tooltip>}
            placement="top"
            delayShow={300}
            delayHide={150}
          >
            <p>{row?.createdByName}</p>
          </OverlayTrigger>
        </>
      ),

      width: "150px",
      sortable: true,
    },

    {
      name: <div className="sticky-tab place-bid-btn">Action </div>,
      selector: (row) => (
        <>
          {dataSingalR?.remainingBidTime == "00:00" ? (
            <p>sdfd</p>
          ) : (
            <div className="sticky-tab place-bid-btn">
              {row?.status === "Live" ? (
                <button
                  className="tablebtn placebid place-bid-btn"
                  onClick={() =>
                    handleSubmit(row, getExectTime(row.recievedAt, row))
                  }
                >
                  Place Bid
                </button>
              ) : (
                <button className="tablebtn placebid disable place-bid-btn" disabled>
                  Place Bid
                </button>
              )}
            </div>
          )}
        </>
      ),
      sortable: true,
      cellClass: "fixed-column", // Add this class for styling
    },
  ];

  // Function to apply the fixed-row class to the last row
  const conditionalRowClassName = (row, rowIndex) => {
    return rowIndex === filteredDataUpcomingLiveAuction?.length - 1
      ? "fixed-row"
      : "";
  };

  const handleSubmit = (item, time) => {
    // Update the item with the timeleft property
    const updatedItem = {
      ...item,
      timeLeft: time, // Add or update the timeleft property
    };
    // Navigate and pass the updated item in the state
    navigate(`/Player/PlaceBid?auctionId`, { state: updatedItem });
  };

  useEffect(() => {
    if (isButtonDisabled) {
      setIsButtonDisabled(true);
    }
  }, [isButtonDisabled]);

  const handleClosed = () => {
    setShowView(false);
  };

  const handleSearchClose = (e) => {
    setSearchTextClose(e.target.value);
  };
  const handleSearchUpcomingLive = (e) => {
    setSearchTextUpcomingLive(e.target.value);
  };

  const handleSearchCloseAuction = (e) => {
    setSearchTextCloseAuction(e.target.value);
  };
  const handleSearchUpcomingLiveAuction = (e) => {
    setSearchTextUpcomingLiveAuction(e.target.value);
  };

  /// new Code

  const filterListData = useMemo(() => {
    let allList =
      BidStatusAuction?.length > 0
        ? BidStatusAuction?.filter((item) => {
            return searchTextUpcomingLive?.length > 0
              ? item?.auctionName
                  ?.toLowerCase()
                  .includes(searchTextUpcomingLive?.toLowerCase()) ||
                  item?.teamName
                    ?.toLowerCase()
                    .includes(searchTextUpcomingLive?.toLowerCase()) ||
                  item?.sportName
                    ?.toLowerCase()
                    .includes(searchTextUpcomingLive?.toLowerCase()) ||
                  item?.createdByName
                    ?.toLowerCase()
                    .includes(searchTextUpcomingLive?.toLowerCase()) ||
                  item?.status
                    .toLowerCase()
                    .includes(searchTextUpcomingLive?.toLowerCase()) ||
                  item?.tournamentName
                    ?.toLowerCase()
                    .includes(searchTextUpcomingLive?.toLowerCase())
              : item;
          })
        : [];

    let liveOnTop = allList.filter((event) => event.status === "Live");
    let otherLeft = allList.filter((event) => event.status !== "Live");
    return [...liveOnTop, ...otherLeft];
  }, [BidStatusAuction, searchTextUpcomingLive]);

  const resultAuction =  BidStatusAuction.map((item) =>  item.status === 'Live' )


  const filteredDataUpcomingLiveAuction = searchTextUpcomingLive
    ? filterUpcomingLiveAuction.filter((item) => {
        return (
          item?.auctionName
            ?.toLowerCase()
            .includes(searchTextUpcomingLive?.toLowerCase()) ||
          item?.teamName
            ?.toLowerCase()
            .includes(searchTextUpcomingLive?.toLowerCase()) ||
          item?.sportName
            ?.toLowerCase()
            .includes(searchTextUpcomingLive?.toLowerCase()) ||
          item?.createdByName
            ?.toLowerCase()
            .includes(searchTextUpcomingLive?.toLowerCase()) ||
          item?.status
            ?.toLowerCase()
            .includes(searchTextUpcomingLive?.toLowerCase()) ||
          item?.tournamentName
          ?.toLowerCase()
          .includes(searchTextUpcomingLive?.toLowerCase())  
        );
      })
    : filterUpcomingLiveAuction;

  const filteredDataCloseAuction = searchTextClose
    ? filterClosedAuction.filter((item) => {
        return (
          item?.auctionName
            ?.toLowerCase()
            .includes(searchTextClose?.toLowerCase()) ||
          item?.teamName
            ?.toLowerCase()
            .includes(searchTextClose?.toLowerCase()) ||
          item.sportName
            ?.toLowerCase()
            .includes(searchTextClose?.toLowerCase()) ||
          item?.createdByName
            ?.toLowerCase()
            .includes(searchTextClose.toLowerCase()) ||
          item?.status?.toLowerCase().includes(searchTextClose?.toLowerCase())
        );
      })
    : filterClosedAuction;

  // useEffect(() => {
  //   if (signalRData && BidStatusAuction) {
  //     const updatedAuctionData = BidStatusAuction?.map((auction) => {
  //       const matchingSignalRAuction = signalRData?.find((signalRAuction) => signalRAuction?.auctionId === auction?.auctionId && signalRAuction?.teamId === auction?.teamId);
  //       if (matchingSignalRAuction) {
  //         auction.currentBidAmount = matchingSignalRAuction?.currentBidAmount;
  //         auction.startingBid = matchingSignalRAuction?.startingBid;
  //         auction.status = matchingSignalRAuction?.status;
  //       }
  //       return auction;
  //     });
  //     setBidStatusAuction(updatedAuctionData);
  //   }

  // }, [signalRData]);

  // var tempTimeOut = false

  // useEffect(() => {
  //   let isListLive = [...BidStatusAuction];

  //   clearInterval(tempTimeOut)
  //   if (isListLive?.length > 0) {
  //     var num = (new Date()).getTime();
  //     let now = moment().utc();

  //     tempTimeOut = setInterval(() => {
  //       let remaingData = isListLive
  //         .filter(function (a) {
  //           // now.isAfter(a.startDate) &&
  //           if (a.status == "Upcoming") {
  //             return { ...a, recievedAt: new Date() }
  //           } else if (now.isAfter(a.startDate) && a.status == "Live") {
  //             let remainingtimer = moment().add(a?.remainingBidTime.split(":")[1], 'minutes').add(a?.remainingBidTime.split(":")[1], 'seconds').format()
  //             return { ...a, recievedAt: remainingtimer }
  //           }
  //           return a
  //           // return (num - new Date(a.startDate + 'Z').getTime()) < 0; })
  //         })

  //       setBidStatusAuction(remaingData)

  //       // let liveFound = remaingData?.filter((event) => event.status === "Live");

  //       // liveFound

  //     }, 1000)
  //   }

  //   return () => {
  //     clearInterval(tempTimeOut)
  //   }
  // }, [BidStatusAuction])

  var tempTimeOut = false;

  useEffect(() => {
    function updateUI(data) {
      setBidStatusAuction((prev) => {
        let newData = prev?.map((item) => {
          if (data.auctionId == item.auctionId && data.teamId == item.teamId) {
            return { ...item, status: "Live" };
          }
          return item;
        });

        return newData;
      });
    }

    function setTimer(TimerData) {
      clearTimeout(tempTimeOut);

      var num = new Date().getTime();

      var tempData = TimerData.sort(function (a, b) {
        return a.teamId - b.teamId;
      })
        .sort(function (a, b) {
          return new Date(a.startDate) - new Date(b.startDate);
        })
        .filter(function (a) {
          return (
            num - new Date(a.startDate + "Z").getTime() < 30000 &&
            num - new Date(a.startDate + "Z").getTime() > 0
          );
        });

      if (tempData.length > 0) {
        var interval = num - new Date(tempData[0]?.startDate + "Z").getTime();
        tempTimeOut = setTimeout(updateUI, interval, tempData?.[0]);
      }
    }

    return () => {
      clearTimeout(tempTimeOut);
    };
  }, [BidStatusAuction]);

  useEffect(() => {
    if (hubConnection) {
      hubConnection.on("ReceiveBidStatus", (data) => {
        // Check if there are any bids that are not closed
        if (data?.filter((e) => e.status !== "Closed")?.length > 0) {
          setBidStatusAuction((prev) => {
            let newData = prev?.map((item) => {
              // Find the current live status for the auction
              let isLiveNow = data?.filter(
                (e) =>
                  e.auctionId === item.auctionId &&
                  e.teamId === item.teamId &&
                  e.status === "Live"
              );
              let isPresentList = data?.filter(
                (e) =>
                  e.auctionId === item.auctionId && e.teamId === item.teamId
              );

              if (isLiveNow?.length > 0) {
                // Update remaining time for live auctions
                let remainingMinutes = parseInt(
                  isLiveNow[0]?.remainingBidTime?.split(":")[0],
                  10
                );
                let remainingSeconds = parseInt(
                  isLiveNow[0]?.remainingBidTime?.split(":")[1],
                  10
                );
                let remainingTimer = moment()
                  .add(remainingMinutes, "minutes")
                  .add(remainingSeconds, "seconds")
                  .format();

                return {
                  ...item,
                  status:
                    isLiveNow[0].status === "Live" &&
                    isLiveNow[0].remainingBidTime === "00:00"
                      ? "Closed"
                      : "Live",
                  totalPoolAmount: isLiveNow[0]?.totalPoolAmount,
                  recievedAt: remainingTimer,
                };
              } else if (isPresentList.length > 0) {
                // If the auction is upcoming, update its status
                if (isPresentList[0]?.status === "Upcoming") {
                  return {
                    ...item,
                    status: "Upcoming",
                    totalPoolAmount: isPresentList[0]?.totalPoolAmount,
                  };
                }
              }

              // If the auction was live but is now closed
              if (item.status === "Live") {
                return { ...item, status: "Closed", recievedAt: new Date() };
              }

              return { ...item, recievedAt: new Date() }; // Default case
            });

            return newData; // Update the state with the new data
          });
        }

        // Optionally, you can set the received data to another state if needed
        // setSignalRData(data);
      });
      hubConnection.on("ReceiveCurrentBid", (data) => {
        // setCurrentTotalPlaceBId(data)
        data?.map((oldRest) => {
          setBidStatusAuction((prev) => {
            let newData = prev?.map((item) => {
              if (
                oldRest.auctionId == item.auctionId &&
                oldRest.teamId == item.teamId &&
                oldRest.status == "Live"
              ) {
                let remainingtimer = moment()
                  .add(oldRest?.remainingBidTime?.split(":")[0], "minutes")
                  .add(oldRest?.remainingBidTime?.split(":")[1], "seconds")
                  .format();
                return {
                  ...item,
                  recievedAt: remainingtimer,
                  currentBidAmount: oldRest.currentBidAmount,
                  totalPlacedBids: oldRest.totalPlacedBids,
                  bidPlacedBy: oldRest.bidPlacedBy,
                  totalPoolAmount: oldRest.totalPoolAmount,
                };
              }
              return item;
            });
            return newData;
          });
        });
      });

       const auctionPlayer =  dataPlayer?.some((item) => item?.managerEmailId === "xcutta2500@gmail.com" && item?.status === 'Approved')

    // if(auctionPlayer){
      hubConnection.on("GetRecentAuction", (data) => {
        setDataLength(data?.length);
        let newData = data?.map((e) => {
          return { ...e, recievedAt: new Date() };
        });

        setBidStatusAuction((prev) => [...newData, ...prev]);

        // Update pagination totals for new auctions
        const liveUpcomingCount = newData.filter(item => ['Live', 'Upcoming', 'Paused'].includes(item.status)).length;
        const closedArchiveCount = newData.filter(item => ['Closed', 'Archive'].includes(item.status)).length;

        setTotalRowsLiveUpcoming(prev => prev + liveUpcomingCount);
        setTotalRowsClosedArchive(prev => prev + closedArchiveCount);
      });

      // Cleanup the event listener on unmount
      return () => {
        hubConnection.off("ReceiveBidStatus");
        hubConnection.off("GetRecentAuction");
        hubConnection.off("ReceiveCurrentBid");
      };
// }
       
    }
  }, [hubConnection, BidStatusAuction]);


  // const options = allManager?.map((manager) => ({
  //   label: `${manager?.firstName} ${manager?.lastName}`,
  //   value: manager?.managerId,
  //   status: manager?.status || 'Active'
  // }));
  const options = allManager?.map((manager) => ({
  label: `${manager?.firstName} ${manager?.lastName}`,
  value: manager?.managerId,
}));
  
const newResponse = options && options?.map(option => {
    // Find the corresponding selected option based on value
    const selectedOption = selectedOptions?.find(selected => selected.value === option.value);
    
    // If a matching selected option is found, include its status and disabled key
    return {
        ...option,
        status: selectedOption ? selectedOption.status : undefined, // Add status if found, otherwise undefined
        disabled: selectedOption ? selectedOption.disabled : false // Add disabled key based on selected option
    };
});

  const handleRequest = async (managerId) => {
    await SubscribeManager(managerId).then((res) => {
      if ((res?.data?.status == true) == true) {
        toast.success(res.data?.message);
      } else {
        toast.error(res?.data?.message);
      }
    });
  };

  const handleChange = (selected) => {
    const addedOptions = selected?.filter(
      (option) =>
        !selectedOptions?.some(
          (selectedOption) => selectedOption?.value === option?.value
        )
      );

    const removedOptions = selectedOptions?.filter(
      (option) =>
        !selected?.some(
          (selectedOption) => selectedOption?.value === option?.value
        )
    );
    setSelectedOptions(selected);

    addedOptions?.forEach((option) => {
      handleRequest(option.value);
    });

    removedOptions?.forEach((option) => {
      if(option?.status === "Approved"){
        console.error('You have already requested to register the user')
      }else{
        handleRequest(option.value);
      }
    });
  };

  // const clearSearch = () => {
  //   setSearchTextUpcomingLive("");
  // };


  // implement searching functionlity from debounce
  const timeoutRef = useRef(null);

  const executeSearch = useCallback((query) => {

    const data = key === "Live" ? {
      // SearchTerm: "Live, Upcoming, Paused",
      SearchTerm: query ? `Live, Upcoming, Paused, ${query}` : "Live, Upcoming, Paused",
      SortColumn: query !== "" ? "" : "status",
      SortOrder: true,
      PageNumber: currentPageCount,
      PageSize: perPage,
    } : {
      SearchTerm: query ? `Closed, Archive, ${query}` : "Closed, Archive",
      // SearchTerm: "Closed, Archive",
      SortColumn: query !== "" ? "" : "status",
      SortOrder: false,
      PageNumber: currentPage1,
      PageSize: perPage1,
    };
    BidAllFn(data);

    console.log("Searching data for:", query);
  }, [key, perPage, perPage1, currentPageCount, currentPage1]);

  // The debounced change handler for the input field
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTextUpcomingLive(value);

    // 1. Clear any previous pending timeouts
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    // 2. Set a new timeout
    timeoutRef.current = setTimeout(() => {
      // 3. Call the actual search function after 2000ms (2 seconds)
      executeSearch(value);
    }, 2000);
  };

  // Function to clear the search input immediately
  const clearSearch = () => {
    // Clear any pending timeouts when the input is cleared manually
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setSearchTextUpcomingLive('');
    // Trigger an immediate clear search (or re-fetch all data)
    executeSearch('');
  };
  

  return (
    <>
      <TopNavbar sidebarfun={sidebarfun} />
      <div className="dasboard-group">
        <Sidebar data={data} />
        <div
          className={
            data ? "dashboard-content full-contnet" : "dashboard-content"
          }
        >
          <Row className="select-dropdown-manager">
            <Col md={6} id="auction">
              <h1 className="heading-dash">Auction</h1>
            </Col>
            <Col md={6}></Col>
          </Row>

          <div className="group_data_table tabs-auction" style={{marginTop: '50px'}} >
            <div className="tabs-box" id="auction-table">
              {managerNames?.length === 0 ? (
                <>
                  <h4>Add Manager To See Auctions</h4>

                  <Form.Group
                    as={Col}
                    md="4 mt-3"
                    lg="2"
                    className="text-left mt-2"
                    controlId="validationCustomOption"
                  >
                    <Form.Label>Select Manager</Form.Label>
                    <MultiSelect 
                      options={options || []}
                      value={selectedOptions || []}
                      onChange={handleChange}
                      labelledBy={"Select"}
                      required
                    />
                  </Form.Group>
                </>
              ) : (
                <>
                  {/* <Row>
                    <Col lg="2" md={4} className="dropdown-manager-approve">
                      <Form.Group controlId="validationCustomOption">
                        <Form.Label>Select Manager</Form.Label>
                        <MultiSelect
                          options={options || []}
                          value={selectedOptions || []}
                          onChange={handleChange}
                          disable={isdisable}
                          labelledBy={"Select"}
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row> */}

                    <Row>
                      <Col lg="2" md={4} className="dropdown-manager-approve"  id='manager-select'>
                        <Form.Group controlId="validationCustomOption">
                          <Form.Label>Select Manager</Form.Label>
                          <MultiSelect
                            options={newResponse || []}
                            value={selectedOptions || []}
                            onChange={handleChange}
                            disable={newResponse.map(option => option.disabled)}
                            labelledBy={"Select"}     
                            required
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                  {loading ? (
                    <Loader />
                  ) : (
                    <Tabs
                      activeKey={key}
                      onSelect={(k) => setKey(k)}
                      id="auctiontabs"
                      className="mb-0 mt-2 tab-list-item player"
                      justify
                    >
                      <Tab eventKey="Live" title="Live and Upcoming">
                        <div>
                          <div className="auctiontabs auction-closed-status ">
                            <div className="search-input filter auction-filter">
                              <Form.Group
                                as={Col}
                                md="mt-3"
                                className="text-left"
                                controlId="validationCustomOption"
                              >
                                <input
                                  type="text"
                                  className="form-control mb-3 mt-3 "
                                  placeholder="Search..."
                                  value={searchTextUpcomingLive}
                                  // onChange={(e) =>
                                  //   setSearchTextUpcomingLive(e.target.value)
                                  // }
                                  onChange={handleSearchChange}
                                />
                                {searchTextUpcomingLive && (
                                  <button
                                    className="btn btn-clear"
                                    onClick={clearSearch}
                                  >
                                    <span>&times;</span>{" "}
                                    {/* This represents the close icon */}
                                  </button>
                                )}
                              </Form.Group>
                            </div>

                            <DataTable
                              columns={columns}
                              data={filterListData?.filter(
                                (event) =>
                                  event.status === "Live" ||
                                  event.status === "Upcoming" ||
                                  event.status === "Paused"
                              )}
                              getRowProps={(row) => ({
                                className:
                                  row.status === "Live"
                                    ? "row-live"
                                    : "row-disabled",
                              })}
                              paginationPerPage={perPage}
                              paginationTotalRows={totalRowsLiveUpcoming}
                              paginationDefaultPage={currentPageCount}
                              onChangePage={setCurrentPage}
                              // onChangePage={dispatch(setCurrentPageCount())}
                            />
                            {totalRowsLiveUpcoming >= 1 && 
                            filterListData?.filter(
                                (event) =>
                                  event.status === "Live" ||
                                  event.status === "Upcoming" ||
                                  event.status === "Paused"
                              ).length > 0 &&
                               (
                              <Row>
                                <Col md={12} className="text-right">
                                  <div className="pagination-controls">
                                    <label>Rows per page: </label>
                                    <select
                                      id="itemsPerPage"
                                      value={perPage}
                                      onChange={handlePerPageChange}
                                    >
                                      {pageOptions.map((option) => (
                                        <option key={option} value={option}>
                                          {option}
                                        </option>
                                      ))}
                                    </select>
                                    <Button
                                      onClick={handlePreviousPage}
                                      disabled={currentPageCount === 1}
                                    >
                                      <icons.ArrowLeft />
                                    </Button>
                                    <span>
                                      {" "}
                                      {currentPageCount} of {totalRowsLiveUpcoming}{" "}
                                    </span>
                                    <Button
                                      onClick={handleNextPage}
                                      disabled={
                                        currentPageCount >=
                                        Math.ceil(totalRowsLiveUpcoming)
                                      }
                                    >
                                      <icons.ArrowRight />
                                    </Button>
                                  </div>
                                </Col>
                              </Row>
                            )}
                          </div>
                        </div>
                      </Tab>
                      <Tab eventKey="Closed" title="Closed">
                        <div>
                          <div className="auctiontabs auction-closed-status" >
                            {/* <div className="search-input filter auction-filter">
                              <input
                                type="text"
                                className="form-control mb-3 mt-3"
                                placeholder="Search..."
                                value={searchTextUpcomingLive}
                                onChange={(e) =>
                                  setSearchTextUpcomingLive(e.target.value)
                                }
                              />
                              {searchTextUpcomingLive && (
                                <button
                                  className="btn btn-clear"
                                  onClick={clearSearch} 
                                >
                                  <span>&times;</span>{" "}
                                </button>
                              )}
                            </div> */}
                                <div className="search-input filter auction-filter">
                                  <input
                                    type="text"
                                    className="form-control mb-3 mt-3"
                                    placeholder="Search..."
                                    value={searchTextUpcomingLive}
                                    onChange={handleSearchChange} // Use the debounced handler
                                  />
                                  {searchTextUpcomingLive && (
                                    <button
                                      className="btn btn-clear"
                                      onClick={clearSearch}
                                    >
                                      <span>&times;</span> {/* This represents the close icon */}
                                    </button>
                                  )}
                                </div>

                            <DataTable
                              columns={columns}
                              data={filterListData?.filter(
                                (event) =>
                                  event.status === "Closed" ||
                                  event.status === "Archive"
                              )}
                              paginationPerPage={perPage1}
                              paginationTotalRows={totalRowsClosedArchive}
                              paginationDefaultPage={currentPage1}
                              onChangePage={setCurrentPage1}
                            />
                            {totalRowsClosedArchive > 1 && 
                            // filterListData?.filter(
                            //     (event) =>
                            //       event.status === "Closed" ||
                            //       event.status === "Archive" ).length > 0 &&
                               (
                              <Row>
                                <Col md={12} className="text-right">
                                  <div className="pagination-controls">
                                    <label>Rows per page: </label>
                                    <select
                                      id="itemsPerPage"
                                      value={perPage1}
                                      onChange={handlePerPageChange1}
                                    >
                                      {pageOptions1.map((option) => (
                                        <option key={option} value={option}>
                                          {option}
                                        </option>
                                      ))}
                                    </select>
                                    <Button
                                      onClick={handlePreviousPage1}
                                      disabled={currentPage1 === 1}
                                    >
                                      <icons.ArrowLeft />
                                    </Button>
                                    <span>
                                      {currentPage1} of {totalRowsClosedArchive}{" "}
                                    </span>
                                    <Button
                                      onClick={handleNextPage1}
                                      disabled={
                                        currentPage1 >=
                                        Math.ceil(totalRowsClosedArchive)
                                      }
                                    >
                                      <icons.ArrowRight />
                                    </Button>
                                  </div>
                                </Col>
                              </Row>
                            )}
                          </div>
                        </div>
                      </Tab>
                    </Tabs>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
        <Footer />
      </div>

      <ModalBox
        show={showView}
        title={
          <>
            <h1 className="heading-dash">Team Detail</h1>
          </>
        }
        body={
          <>
            <Table bordered hover className="table-team border">
              <thead>
                <tr>
                  <th>Logo</th>
                  <th>Team Name</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {" "}
                    <Image src="/image/team-icon.png" width={50} />
                  </td>
                  <td>Team 1</td>
                </tr>
              </tbody>
            </Table>
          </>
        }
        footer={
          <>
            <Button variant="secondary close-btn" onClick={handleClosed}>
              <CloseRounded />
            </Button>
          </>
        }
      />

      <ModalBox
        show={auctionPlaceModal}
        dialogClassName="custom-modal" 
        headerClassName="custom-modal-header"
        title={
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-md-4">
                <h1 className="heading-dash text-left">
                  Auction Winnings
                </h1>
              </div>

              <div className="col-md-8">
                <div className="row justify-content-between">
                  <div className="col-4 text-center">
                    <div className="mb-2" style={{
                      fontSize: '14px',
                      color: '#000',
                      fontWeight: 'bold'
                    }}>
                      Total Pool
                    </div>
                    <div style={{
                      fontSize: '16px',
                      color: '#000',
                      // fontWeight: 'bold'
                    }}>
                      {(auctionPlacedata?.[0]?.totalPool || 0).toFixed(2)}
                    </div>
                  </div>
                  <div className="col-4 text-center">
                    <div className="mb-2" style={{
                      fontSize: '14px',
                      color: '#000',
                      fontWeight: 'bold'
                    }}>
                      Manager Hold
                    </div>
                    <div style={{
                      fontSize: '16px',
                      color: '#000',
                      // fontWeight: 'bold'
                    }}>
                      {(`${auctionPlacedata?.[0]?.xcuttaTake}%` || 0)}
                    </div>
                  </div>
                  <div className="col-4 text-center">
                    <div className="mb-2" style={{
                      fontSize: '14px',
                      color: '#000',
                      fontWeight: 'bold'
                    }}>
                      Net Pool
                    </div>
                    <div style={{
                      fontSize: '16px',
                      color: '#000',
                      // fontWeight: 'bold'
                    }}>
                      {(auctionPlacedata?.[0]?.netPool || 0).toFixed(2)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
        body={
          <div className="row">
            <Table bordered>
              <thead>
                <tr>
                  {[
                    "Winner Title",
                    "Winner Percentage",
                    "Winner Amount"
                  ].map((header, index) => (
                    <th
                      key={index}
                      className="bg-gray-view"
                      style={{
                        padding: "10px",
                        border: "1px solid #ccc",
                        textAlign: "center",
                      }}
                    >
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {auctionPlacedata?.map((item, index) => (
                  <tr key={index} style={{ textAlign: 'center' }}>
                    <td>
                      {item?.winnerTitle}
                    </td>
                    <td>
                      {`${item?.winnerPercentage}%`}
                    </td>
                    <td>
                      {(item?.winningAmount || 0).toFixed(2)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            {/* </div> */}
          </div>
        }
        footer={
          <Button variant="secondary" onClick={handleAuctionPalceBitClosed}>
            Close
          </Button>
        }
      />
    </>
  );
}

export default AuctionPlayer;